// "The short version": the one-screen résumé at the top of the home page.
// Wrap a phrase in ==double equals== to highlight it as a key result.

export interface ResumeRow {
  year: string;
  months?: string;
  org: string;
  title: string;
  detail?: string;
  caseStudy?: string;
  note?: string;
}

export const experience: ResumeRow[] = [
  {
    year: "2026",
    months: "May–Aug",
    org: "Cloudsway",
    title: "AI Data Quality & Automation Intern",
    detail:
      "Reconciled a ==29,356-object== multimodal data migration and built an internal data workbench for about 30–40 colleagues.",
    caseStudy: "cloudsway",
    note: "The case study I’d start with",
  },
  {
    year: "2025",
    months: "May–Aug",
    org: "EQuota Energy",
    title: "Machine Learning Engineer Intern",
    detail:
      "Automated ingestion of 20,000+ daily weather-forecast files, cutting latency from ==hours to minutes==.",
    note: "Same company, second summer",
  },
  {
    year: "2024",
    months: "May–Nov",
    org: "EQuota Energy",
    title: "Algorithm Engineer Intern",
    detail:
      "Cut validation forecast error (MAPE) from ==9.3% to 5.6%== across three pilot sites.",
    caseStudy: "equota",
  },
  {
    year: "2023",
    months: "Jun–Aug",
    org: "Nike",
    title: "Business Data Analyst Intern",
    detail:
      "Built a Python pipeline for 530,000+ supply-chain records and analyzed two Nike App A/B tests.",
  },
];

export const education: ResumeRow[] = [
  {
    year: "2027",
    months: "Exp. Dec",
    org: "Penn",
    title: "M.S.E., Data Science & Artificial Intelligence",
    detail: "University of Pennsylvania, AI concentration.",
  },
  {
    year: "2026",
    months: "May",
    org: "Illinois",
    title: "B.S., Information Sciences + Data Science",
    detail:
      "University of Illinois Urbana-Champaign. ==4.0 GPA==, Bronze Tablet.",
    note: "Bronze Tablet: top 3% of my college’s graduating class",
  },
];

export const tools: { area: string; items: string }[] = [
  {
    area: "Modeling",
    items:
      "scikit-learn, XGBoost, LightGBM, time-series validation, LLM evaluation, RAG",
  },
  {
    area: "Data",
    items: "Python, SQL, R, pandas, PySpark, PostgreSQL, DuckDB",
  },
  {
    area: "Building",
    items: "FastAPI, Django REST, React, TypeScript, Streamlit",
  },
];
